import React from 'react'
import { makeStyles } from '@material-ui/styles'
import HandicapIconsList from 'components/molecules/HandicapIconsList'
import { Link, Button } from '@material-ui/core'
import pictoLogoLink from 'assets/images/pictoaccess-logo.png'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    cursor: 'pointer',
  },
  informations: {
    flex: '1 0 auto',
  },
  pictoLogo: {
    width: theme.spacing(13),
  },
  otherLogo: {
    width: theme.spacing(13),
    height: theme.spacing(13),
    objectFit: 'contain',
    alignSelf: 'flex-start',
  },
  alignContent: {
    textAlign: 'center',
    marginTop: theme.spacing(1),
  },
}))

const HorizontalWidgetPage = (props) => {
  const { handicaps, cardUrl, picture } = props
  const classes = useStyles()
  const openCard = () => window.open(cardUrl)
  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') openCard()
  }

  return (
    <div
      onClick={openCard}
      onKeyDown={handleKeyDown}
      className={classes.root}
      role="link"
      tabIndex={0}
    >
      <img src={`https://${picture}`} className={classes.otherLogo} alt="" />
      <div className={classes.informations}>
        <HandicapIconsList handicaps={handicaps} />
        <div className={classes.alignContent}>
          <Button
            target="_blank"
            href={cardUrl}
            color="primary"
            variant="contained"
          >
            Consulter l'accessibilité
          </Button>
        </div>
        <div className={classes.alignContent}>
          <Link href={cardUrl} target="_blank">
            <img
              src={pictoLogoLink}
              className={classes.pictoLogo}
              alt="PictoAccess"
            />
          </Link>
        </div>
      </div>
    </div>
  )
}

export default HorizontalWidgetPage
